import { Modal, toast } from "@devhop/ui";
import {
  useAddSkuMedia,
  useDeleteSkuMedia,
  useReorderSkuMedia,
  useSkuMediaQuery,
} from "../api/queries";
import { SkuMediaSection } from "./SkuMediaSection";

type SkuMediaModalProps = {
  skuId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  canManage?: boolean;
};

export function SkuMediaModal({
  skuId,
  open,
  onOpenChange,
  canManage,
}: SkuMediaModalProps) {
  const mediaQuery = useSkuMediaQuery(skuId);
  const addMedia = useAddSkuMedia(skuId);
  const deleteMedia = useDeleteSkuMedia(skuId);
  const reorderMedia = useReorderSkuMedia(skuId);
  const media = mediaQuery.data ?? [];

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="ຈັດການຮູບ SKU"
      description="ເພີ່ມ · ແກ້ໄຂ · ລຶບ · ລາກຈັດລຳດັບ — ຮູບແລກເປັນ Thumbnail"
      size="lg"
      className="sm:max-w-4xl md:max-w-5xl"
    >
      <div className="max-h-[75vh] overflow-y-auto pr-1">
        <SkuMediaSection
          skuId={skuId}
          media={media}
          isLoading={mediaQuery.isLoading}
          canManage={canManage}
          onAdd={async (url) => {
            try {
              await addMedia.mutateAsync(url);
              toast.success("ເພີ່ມຮູບສຳເລັດ");
            } catch {
              toast.error("ເພີ່ມຮູບລົ້ມເຫຼວ");
            }
          }}
          onDelete={async (mediaId) => {
            try {
              await deleteMedia.mutateAsync(mediaId);
              toast.success("ລຶບຮູບສຳເລັດ");
            } catch {
              toast.error("ລຶບຮູບລົ້ມເຫຼວ");
            }
          }}
          onReplace={async (mediaId, url) => {
            try {
              const created = await addMedia.mutateAsync(url);
              const nextOrder = media.map((m) =>
                m.id === mediaId ? created.id : m.id,
              );
              await reorderMedia.mutateAsync(nextOrder);
              await deleteMedia.mutateAsync(mediaId);
              toast.success("ແກ້ໄຂຮູບສຳເລັດ");
            } catch {
              toast.error("ແກ້ໄຂຮູບລົ້ມເຫຼວ");
            }
          }}
          onReorder={async (mediaIds) => {
            try {
              await reorderMedia.mutateAsync(mediaIds);
              toast.success("ຈັດລຳດັບຮູບສຳເລັດ");
            } catch {
              toast.error("ຈັດລຳດັບຮູບລົ້ມເຫຼວ");
            }
          }}
        />
      </div>
    </Modal>
  );
}
